import { createApp, h } from 'vue';
import ProposalSliders from '@components-molecules/ProposalSliders.vue';

export const selectionSliderManager = () => {
  const container = document.createElement('div');
  document.body.appendChild(container);
  const component = {
    render: () => h(ProposalSliders),
  };

  return createApp(component).mount(container);
};
